<div class="chat-boundary" #chatBoundary>
  <div class="chat-window" [cdkDragBoundary]="chatBoundary" cdkDrag [class.minimized]="isMinimized">

    <div class="chat-header" cdkDragHandle>
      <div>
        <img src="../../../assets/feature-images/iris-logo.png"  alt="chat-bot" class="robot"  >
        <span class="title">Ask Iris</span>
        <img width="25px" src="../../../assets/images/beta-version.png" >
      </div>

      <div class="header-actions">
  
        <button mat-icon-button (click)="toggleMinimize()" [matTooltip]="isMinimized ? 'Expand' : 'Minimize'">
          <mat-icon>
            {{ isMinimized ? 'open_in_full' : 'remove' }}
          </mat-icon>
        </button>
        <button *ngIf="!isMinimized" mat-icon-button (click)="clearChat()" matTooltip="Clear chat">
          <mat-icon>delete_outline</mat-icon>
        </button>
        <button mat-icon-button (click)="closeChat()" matTooltip="Close chat">
          <mat-icon>close_outline</mat-icon>
        </button>
      </div>
    </div>


    <ng-container *ngIf="!isMinimized">

      <div class="messages">
        <div
          class="message"
          *ngFor="let msg of messages; let i = index"
          [ngClass]="msg.sender"
        >
          <div class="avatar">
            <div class="assistant-avatar" *ngIf="msg.sender === 'assistant'">
              <img src="../../../assets/feature-images/iris-logo.png" />
            </div>
            <img [class]="this.userImg ? 'user-pr': ''" *ngIf="msg.sender === 'user'" [src]="this.userImg ? this.userImg : '../../../../assets/images/user-light.svg'"/>
          </div>

          <div class="bubble">
            <div class="bubble-content">
              <div #msgBody [innerHTML]="msg.message"></div>
            </div>
            <div class="timestamp">{{ msg.formatTime.split(' - ')[1] }}</div>
            <button [cdkCopyToClipboard]="msgBody.innerText" *ngIf="msg.sender === 'assistant'" mat-icon-button matTooltip="Copy" class="copy-btn"  matTooltipPosition="below">
              <mat-icon class="material-icons-outlined">content_copy</mat-icon>
            </button>
            
          </div>
            
        </div>
        <div class="message assistant" *ngIf="loading">
          <div class="avatar">
            <div class="assistant-avatar">
              <img src="../../../assets/feature-images/iris-logo.png" />
            </div>
          </div>
          <div class="bubble">
            <span class="typing-dot"></span>
            <span class="typing-dot"></span>
            <span class="typing-dot"></span>
          </div>
        </div>
      </div>

      <div class="chat-footer" >
        <div class="drag-footer-overlay"cdkDragHandle></div>
        <form class="group" [formGroup]="chatForm" (ngSubmit)="sendMessage($event)">
          <textarea class="custom-scroll" (keydown.enter)="onEnter($event)" formControlName="message" placeholder="Type a message..."></textarea>

            <button mat-icon-button class="send-btn" [disabled]="loading || chatForm.get('message')?.value?.trim() === ''" type="submit" >
              <mat-icon>send</mat-icon>
            </button>
          
            <button mat-icon-button class="send-btn" [disabled]="loading || messages.length === 1 || disableMail" (click)="sendMail()" matTooltip="Contact CSM" >
              <mat-icon>attach_email</mat-icon>
            </button>
        </form>
        <div class="cs-info-container">
          <div class="cs-inline" [class.expanded]="isExpanded">
            <span class="cs-text">
              Iris may provide inaccurate results. She is intended to handle EARTHEYE support enquiries only. If in doubt about her response, please request a human agent to contact you. The platform's
              <a (click)="goToTerms()" class="terms-link">terms of use (TOU)</a>
              apply to your use of the Ask Iris feature.
            </span>

            <a class="view-toggle-link"
              (click)="toggleExpand()">
              {{ isExpanded ? 'View Less' : 'View More' }}
            </a>
          </div>
        </div>
      </div>

    </ng-container>

  </div>
</div>
<ng-template #successDialog class="success-popup">
  <h2 style="padding: 0 0 10px; border-bottom: 1px solid #eee; margin: 0 0 20px; text-align: center;" mat-dialog-title>Success!</h2>

  <mat-dialog-content>
    <p style="font-size: 16px;text-align: center;">Mail sent successfully to CSM</p>
  </mat-dialog-content>

  <mat-dialog-actions align="center">
    
    <div class="btns">
      <button mat-flat-button color="primary" mat-dialog-close>Ok</button>
    </div>    
  </mat-dialog-actions>
</ng-template>
